export const ANSWER_SURVEY = 'ANSWER_SURVEY';
export const SELECT_SURVEY = 'SELECT_SURVEY';
export const PREVIOUS_QUESTION = 'PREVIOUS_QUESTION';
export const PREVIOUS_SECTION = 'PREVIOUS_SECTION';
export const TO_NEXT_SECTION = 'TO_NEXT_SECTION';
export const SAVE_USER_EMAIL = 'SAVE_USER_EMAIL';
export const BROWSER_PREVIOUS_SECTION = 'BROWSER_PREVIOUS_SECTION';
export const SUBMIT_ANSWERS_CHECKED = 'SUBMIT_ANSWERS_CHECKED';
export const MOVE_TO_NEXT_QUESTION = 'MOVE_TO_NEXT_QUESTION';
export const RESET_QUESTIONS = 'RESET_QUESTIONS';
export const ADD_CONDITIONAL_QUESTION = 'ADD_CONDITIONAL_QUESTION';
export const REMOVE_CONDITIONAL_QUESTION = 'REMOVE_CONDITIONAL_QUESTION';
export const REMOVE_CONDITIONAL_ANSWERS = 'REMOVE_CONDITIONAL_ANSWERS';